import React from 'react';
import { ServiceIProvide } from '../../Store';
import Service from '../Service/Service';
import './whatido.scss';
const WhatIDo = () => {

    const service = ServiceIProvide;
    return (
        <div className="what-i-do">
            <div className="container">
                <div className="component-head">
                <h2>What I do?</h2>
            </div>

            <div className="do-cards">
                <div className="do-card">
                    {
                        service.map(services => <Service service={services}></Service>)
                    }
                </div>
            </div>
            </div>
        </div>
    );
};

export default WhatIDo;